<app-loading-indicator></app-loading-indicator>
<router-outlet />